import { css } from "@emotion/react";

export const baseInputCss = css`
  background-color: #fff;
  padding: 4px;
  border: 1px solid;
  width: 100%;
  box-sizing: border-box;
  padding: 14px 22px;
  border: 2px solid #f0f0f0;
  border-radius: 8px;
  font-size: 16px;
  color: rgba(66, 66, 66, 1);

  :focus {
    border-color: var(--primary-color);
  }

  ::placeholder,
  :invalid {
    color: var(--gray-600);
  }

  &[data-invalid="true"] {
    border-color: var(--red);
  }
`;

export const baseInputIosFixCss = css`
  &[data-is-ios="true"] {
    display: block;
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    min-height: 1.2em;

    &[data-is-empty="true"]:after {
      color: #aaa;
      content: attr(placeholder);
    }
  }
`;
